import React from "react";
import { getAssets } from "@unisearch/helpers";
import { Grid } from "@mui/material";
import styles from "./technology.module.scss";

export const UniPageDiversifyTechnology = () => {
  return (
    <section className={styles.section_tech}>
      <div className="container">
        <Grid container spacing={4} alignItems="center">
          <Grid item md={6} xs={12}>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets("assets/images/unipage/uni_technology.png")}
                alt="University Technology"
                width="100%"
              />
            </div>
          </Grid>
          <Grid item md={6} xs={12}>
            <h2>
              Combining Regional Market Experience with Smart Data-Driven
              Technology
            </h2>
            <p className={`${styles.sub_title}`}>
              Our multi-fold approach combines smart technology with our
              decade-long insight and experience in emerging markets to
              streamline student recruitment for our university partners.
            </p>
            <p className={`${styles.sub_title}`}>
              Our AI-driven profile matching system quickly screens prospects
              for the candidates best matching your university’s eligibility
              requirements. With a few clicks, you have access to the prospects
              with the highest likelihood of converting into active applicants.
              We help you cut down on the time and resources you would expend
              handpicking the best candidates by bringing them right to you
              instead, letting you allocate those resources elsewhere.
            </p>
            <p>
              We also help you develop a richer and nuanced understanding of the
              characteristics of each market. Through live analytics and our
              published market intelligence reports, you have a deeper insight
              into the consumer behaviour and engagement patterns of students
              from specific market niches. With this, you get to develop more
              effective marketing and recruiting strategies.
            </p>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default UniPageDiversifyTechnology;
